import { Field, Label } from '../../catalyst/fieldset';
import { Input } from '../../catalyst/input';
import { Select } from '../../catalyst/select';
import { Button } from '../../catalyst/button';
import { hasActiveFilters, type CategoriesFilterValues } from './categoriesFilters.types';

interface CategoriesFiltersProps {
  filters: CategoriesFilterValues;
  setFilters: (filters: CategoriesFilterValues) => void;
  onClear: () => void;
}

export default function CategoriesFilters({ filters, setFilters, onClear }: CategoriesFiltersProps) {
  const hasFilters = hasActiveFilters(filters);

  return (
    <div className="mb-6">
      <div className="flex gap-4 md:flex-row flex-col">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
          <Field>
            <Label htmlFor="filter-name">Name</Label>
            <Input
              id="filter-name"
              type="text"
              className="catalyst-input mt-1"
              placeholder="Filter by name"
              value={filters.name}
              onChange={(e) => setFilters({ ...filters, name: e.target.value })}
            />
          </Field>
          <Field>
            <Label htmlFor="filter-needs-training">Needs Training</Label>
            <Select
              id="filter-needs-training"
              className="catalyst-input mt-1"
              value={filters.needsTraining}
              onChange={(e) => setFilters({ ...filters, needsTraining: e.target.value })}
            >
              <option value="">All</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </Select>
          </Field>
          <Field>
            <Label htmlFor="filter-excluded">Excluded</Label>
            <Select
              id="filter-excluded"
              className="catalyst-input mt-1"
              value={filters.excluded}
              onChange={(e) => setFilters({ ...filters, excluded: e.target.value })}
            >
              <option value="">All</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </Select>
          </Field>
        </div>

        <div className="flex items-end">
          <Button
            outline
            onClick={onClear}
            className="whitespace-nowrap w-full md:w-auto"
            disabled={!hasFilters}
          >
            Clear Filters
          </Button>
        </div>
      </div>
    </div>
  );
}
